import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-purchase-order-edit-popup',
  template: `
  <app-page-card-header title="PURCHASE ORDER {{id}}" (onBack)="dialogRef.close()">
  </app-page-card-header>
    <app-purchase-order-edit [id]="id" [inPopup]="true" (onSubmitted)="dialogRef.close(true)" (onBack)="dialogRef.close()"></app-purchase-order-edit>`
})
export class PurchaseOrderEditPopupComponent implements OnInit {
  public id;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
    public dialogRef: MatDialogRef<PurchaseOrderEditPopupComponent>,
  ) {
    if (this.data.id) {
      this.id = data.id;
    }
  }

  ngOnInit() {
  }
}
